// // import React, { useState, useCallback } from "react";
// // import QrReader from "react-qr-scanner";
// // import axiosInstance from "../Services/axios";
// // import { useEffect } from "react";
// // import { Navigate, useNavigate } from "react-router-dom";
// // import { useHistory } from "react-router-dom";
// // import { showToast } from "./toastConfig/ToastConfig";

// // const Scanner = () => {
// //   const [result, setResult] = useState("No result");
// //   const [extractedValue, setExtractedValue] = useState("");
// //   const [scanning, setScanning] = useState(true);
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     vendorDetails();
// //   }, [extractedValue]);

// //   const vendorDetails = async (vendorQrId) => {
// //     try {
// //       const reqData = { vendor_qr_id: vendorQrId };
// //       const res = await axiosInstance.post("/user/vendor_qr_search", reqData);

// //       if (res.status === 200) {
// //         navigate(`/vendor/${res.data.vendor_id}`);
// //       }
// //     } catch (err) {
// //       if (err.response) {
// //         console.log("response err", err);
// //         if (
// //           err.response.data.message === "Invalid QR code." ||
// //           err.response.status === 400
// //         ) {
// //           showToast("Invalid QR code. Please scan a valid merchant QR code");
// //           setTimeout(() => setScanning(true), 1000);
// //         }
// //       } else if (err.request) {
// //         console.error("No response received:", err.request);
// //       } else {
// //         console.error("Request setup error:", err.message);
// //       }
// //     }
// //   };

// //     const stopCamera = useCallback(() => {
// //     const video = document.querySelector("video");
// //     if (video && video.srcObject) {
// //       const stream = video.srcObject;
// //       const tracks = stream.getTracks();
// //       tracks.forEach((track) => track.stop());
// //       video.srcObject = null;
// //     }
// //   }, []);


// // const handleScan = useCallback(
// //   (data) => {
// //     if (data?.text && scanning) {
// //       const url = data.text.trim();
// //       const baseUrl = "https://pingle.page.link/";
// //       const extractedValue = url.startsWith(baseUrl)
// //         ? url.slice(baseUrl.length)
// //         : url;

// //       // Stop scanning only if it’s a proper QR
// //       setResult(url);
// //       setExtractedValue(extractedValue);
// //       setScanning(false);
// //       stopCamera();
// //       vendorDetails(extractedValue);  // pass extractedValue as param
// //     }
// //   },
// //   [scanning, stopCamera]
// // );


// //   const handleError = useCallback((err) => {
// //     console.error(err);
// //   }, []);


// //   const previewStyle = {
// //     height: "100%",
// //     width: "100%",
// //   };

// //   const videoConstraints = {
// //     facingMode: "environment", // This requests the rear camera
// //   };

// //   return (
// //     <div style={{ width: "100%", height: "100%", position: "relative" }} >
// //       {scanning && (
// //         <QrReader
// //           delay={300}
// //           style={previewStyle}
// //           onError={handleError}
// //           onScan={handleScan}
// //           constraints={{ video: videoConstraints }}
// //           showViewFinder={false}
// //         />
// //       )}
// //       {/* {!scanning && <p>Vendor_Qr_ID: {extractedValue}</p>} */}
// //     </div>
// //   );
// // };

// // export default Scanner;


// // // import { Html5QrcodeScanner } from "html5-qrcode";

// // // const Scanner = () => {
// // //   useEffect(() => {
// // //     const html5QrcodeScanner = new Html5QrcodeScanner(
// // //       "reader",
// // //       { fps: 10, qrbox: { width: 250, height: 250 } },
// // //       /* verbose= */ false
// // //     );

// // //     html5QrcodeScanner.render(
// // //       (decodedText, decodedResult) => {
// // //         console.log("Decoded text:", decodedText);
// // //         setExtractedValue(decodedText);
// // //         html5QrcodeScanner.clear();
// // //       },
// // //       (error) => console.error("Scan error:", error)
// // //     );

// // //     return () => {
// // //       html5QrcodeScanner.clear();
// // //     };
// // //   }, []);

// // //   return <div id="reader" style={{ width: "100%", height: "100%" }} />;
// // // };



// // import React, { useState, useCallback } from "react";
// // import QrReader from "react-qr-scanner";
// // import axiosInstance from "../Services/axios";
// // import { useNavigate } from "react-router-dom";
// // import { showToast } from "./toastConfig/ToastConfig";

// // const Scanner = () => {
// //   const [result, setResult] = useState("No result");
// //   const [scanning, setScanning] = useState(true);
// //   const navigate = useNavigate();

// //   const stopCamera = useCallback(() => {
// //     const video = document.querySelector("video");
// //     if (video && video.srcObject) {
// //       const stream = video.srcObject;
// //       const tracks = stream.getTracks();
// //       tracks.forEach((track) => track.stop());
// //       video.srcObject = null;
// //     }
// //   }, []);

// //   const vendorDetails = async (vendorQrId) => {
// //     try {
// //       const reqData = { vendor_qr_id: vendorQrId };
// //       const res = await axiosInstance.post("/user/vendor_qr_search", reqData);

// //       if (res.status === 200) {
// //         navigate(`/vendor/${res.data.vendor_id}`);
// //       }
// //     } catch (err) {
// //       console.error("Vendor fetch error:", err);

// //       if (err.response && err.response.status === 400) {
// //         showToast("Invalid QR code. Please scan a valid merchant QR code");
// //         setTimeout(() => setScanning(true), 1500);
// //       } else if (err.request) {
// //         console.error("No response received:", err.request);
// //       } else {
// //         console.error("Request setup error:", err.message);
// //       }
// //     }
// //   };

// //   const handleScan = useCallback(
// //     (data) => {
// //       if (data?.text && scanning) {
// //         const url = data.text.trim();
// //         const baseUrl = "https://pingle.page.link/";
// //         const extractedValue = url.startsWith(baseUrl)
// //           ? url.slice(baseUrl.length)
// //           : url;

// //         setResult(url);
// //         setScanning(false);
// //         stopCamera();
// //         vendorDetails(extractedValue); // Pass extracted value
// //       }
// //     },
// //     [scanning, stopCamera]
// //   );

// //   const handleError = useCallback((err) => {
// //     console.error("QR Scan error:", err);
// //   }, []);

// //   const previewStyle = {
// //     height: "100%",
// //     width: "100%",
// //   };

// //   const videoConstraints = {
// //     facingMode: "environment",
// //   };

// //   return (
// //     <div style={{ width: "100%", height: "100%", position: "relative" }}>
// //       {scanning && (
// //         <QrReader
// //           delay={300}
// //           style={previewStyle}
// //           onError={handleError}
// //           onScan={handleScan}
// //           constraints={{ video: videoConstraints }}
// //           showViewFinder={false}
// //         />
// //       )}
// //     </div>
// //   );
// // };

// // export default Scanner;

// import React, { useState, useCallback, useRef } from "react";
// import QrReader from "react-qr-scanner";
// import axiosInstance from "../Services/axios";
// import { useNavigate } from "react-router-dom";
// import { showToast } from "./toastConfig/ToastConfig";
// import axios from "axios";


// const Scanner = () => {
//   const [result, setResult] = useState("No result");
//   const [scanning, setScanning] = useState(true);
//   const [torchOn, setTorchOn] = useState(false);
//   const navigate = useNavigate();
//   const videoRef = useRef(null);

//   const stopCamera = useCallback(() => {
//     const video = document.querySelector("video");
//     if (video && video.srcObject) {
//       const stream = video.srcObject;
//       const tracks = stream.getTracks();
//       tracks.forEach((track) => track.stop());
//       video.srcObject = null;
//     }
//   }, []);

//   // const fetchLink = async (param) => {
//   //   try {

//   //     let link = param;
//   //     const shortCode = link.split("/").pop();
//   //     console.log("Short code extracted:", shortCode);
//   //     const params = {
//   //       'short_code': shortCode
//   //     }
//   //     const response = await axios.get("https://link.pingle.in/get_link", { params: { code: shortCode } });

//   //     if (response.status == 200) {
//   //       const data = response?.data;

//   //       const linkData = data?.link?.data;
//   //       if (linkData?.type == "VendorProfile") {
//   //         setTimeout(() => {
//   //           navigate("MerchantProfile", { merchant_id: linkData?.vendor_id });
//   //         }, 100);
//   //       } else if (linkData?.type == "VendorOffer") {
//   //         setTimeout(() => {
//   //           navigate("ViewOfferDetails", { applied_to_status: "0", vendor_id: linkData?.vendor_id, offer_id: linkData?.offer_id });
//   //         }, 100);
//   //       } else if (linkData?.type == "VendorMembership") {
//   //         setTimeout(() => {
//   //           navigate('MembershipDetails', { membership_id: linkData?.membership_id, vendor_id: linkData?.vendor_id, byMembership: 1, })
//   //         }, 100);
//   //       } else if (linkData?.type == "VendorMembershipList") {
//   //         setTimeout(() => {
//   //           navigate('MembershipBuy', { Vendor_id: linkData?.vendor_id, MembershipNavigation: 1, })
//   //         }, 100);
//   //       } else if (linkData?.type == "VendorOffersList") {
//   //         setTimeout(() => {
//   //           navigate("MerchantOffers", { vendor_id: linkData?.vendor_id });
//   //         }, 100);
//   //       } else if (linkData?.type == "ServiceBooking") {
//   //         setTimeout(() => {
//   //           navigate('ServicePasses', { BookingId: linkData?.booking_id, User_id: linkData?.user_id });
//   //         }, 100);
//   //       } else if (linkData?.type == "ProductOrder") {
//   //         setTimeout(() => {
//   //           navigate("ProductPass", { orderId: linkData?.order_id });
//   //         }, 100);
//   //       } else if (linkData?.type == "MyMembership") {
//   //         setTimeout(() => {
//   //           navigate("MyMembership", { Vendor_id: linkData?.vendor_id })
//   //         }, 100);
//   //       } else if (linkData?.type == "VendorPreorderTicket") {
//   //         setTimeout(() => {
//   //           navigate("PreorderDetails", { ticketId: linkData?.ticket_id, vendorId: linkData?.vendor_id, date: linkData?.date })
//   //         }, 100);
//   //       } else {
//   //         showToast('Invalid QR');

//   //       }

//   //     }
//   //   } catch (err) {
//   //     if (err.response) {
//   //       if (err.response.status == 400) {
//   //         showToast('Invalid QR');
//   //       }
//   //       if (err.response.status == 500) {
//   //         showToast('something went wrong please try again');
//   //       }
//   //     } else {
//   //       setScanning(true);

//   //       showToast('something went wrong please try again');
//   //     }
//   //   }

//   // }

//   const vendorDetails = async (vendorQrId) => {
//     try {
//       const reqData = { vendor_qr_id: vendorQrId };
//       const res = await axiosInstance.post("/user/vendor_qr_search", reqData);
//       if (res.status == 200) {
//         stopCamera();
//         navigate(`/vendor/${res.data.vendor_id}`, { replace: true });
//       }
//     } catch (err) {
//       // console.error("Vendor fetch error:", err);
//       if (err.response && err.response.status == 400) {
//         showToast("Invalid QR code. Please scan a valid merchant QR code");
//         setScanning(true);
//       }
//     }
//   };


//   const [scanInProgress, setScanInProgress] = useState(false);

//   const handleScan = useCallback(
//     (data) => {
//       if (data?.text && !scanInProgress) {
//         setScanInProgress(true);
//         const url = data.text.trim();
//         const baseUrl = "https://pingle.page.link/";
//         const extractedValue = url.startsWith(baseUrl)
//           ? url.slice(baseUrl.length)
//           : url;
//         console.log("Extracted Value:", extractedValue);
//         setScanning(false);
//         // fetchLink(extractedValue).finally(() => {
//         //   setScanInProgress(false);
//         // });
//         vendorDetails(extractedValue).finally(() => {
//           setScanInProgress(false);
//         });
//       }
//     },
//     [scanInProgress]
//   );


//   const handleError = useCallback((err) => {
//     console.error("QR Scan error:", err);
//   }, []);

//   const toggleTorch = async () => {
//     const video = document.querySelector("video");
//     const stream = video?.srcObject;
//     const track = stream?.getVideoTracks?.()[0];

//     if (track && track.getCapabilities) {
//       const capabilities = track.getCapabilities();
//       if (capabilities.torch) {
//         try {
//           await track.applyConstraints({
//             advanced: [{ torch: !torchOn }],
//           });
//           setTorchOn(!torchOn);
//         } catch (error) {
//           console.error("Torch toggle error:", error);
//         }
//       } else {
//         showToast("Torch not supported on this device");
//       }
//     }
//   };

//   const previewStyle = {
//     height: "100%",
//     width: "100%",
//   };

//   const videoConstraints = {
//     facingMode: "environment",
//   };

//   return (
//     <div style={{ width: "100%", height: "100%", position: "relative" }}>
//       {scanning && (
//         <QrReader
//           delay={300}
//           style={previewStyle}
//           onError={handleError}
//           onScan={handleScan}
//           constraints={{ video: videoConstraints }}
//           showViewFinder={false}
//         />
//       )}

//     </div>
//   );
// };

// export default Scanner;


import React, { useState, useCallback } from "react";
import QrReader from "react-qr-scanner";
import axiosInstance from "../Services/axios";
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom";

const Scanner = () => {
  const [result, setResult] = useState("No result");
  const [extractedValue, setExtractedValue] = useState("");
  const [scanning, setScanning] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    vendorDetails();
  }, [extractedValue]);

  const vendorDetails = () => {
    try {
      const reqData = {
        vendor_qr_id: extractedValue,
      };
      axiosInstance
        .post("/user/vendor_qr_search", reqData)
        .then((res) => {
          if (res.status === 200) {
            navigate(`/vendor/${res.data.vendor_id}`)
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 400 || err.response.status === 500) {
              console.error("Error response from server:", err.response.data);
              // Handle specific error cases here
            } else {
              console.error("Error occurred in request:", err.message);
              // Handle other types of errors
            }
          } else if (err.request) {
            // The request was made but no response was received
            console.error("No response received:", err.request);
          } else {
            // Something happened in setting up the request that triggered an error
            console.error("Request setup error:", err.message);
          }
        });
    } catch (error) {
      // This catch block won't catch asynchronous errors from Axios
      alert("Try again later");
    }
  };

  const handleScan = useCallback(
    (data) => {
      if (data) {
        const url = data.text;
        const baseUrl = "https://pingle.page.link/";
        const extractedValue = url.startsWith(baseUrl)
          ? url.slice(baseUrl.length)
          : url;

        setResult(url);
        setExtractedValue(extractedValue);
        setScanning(false);
        stopCamera();
        vendorDetails();
      }
    },
    [vendorDetails]
  );

  const handleError = useCallback((err) => {
    console.error(err);
  }, []);

  const stopCamera = useCallback(() => {
    const video = document.querySelector("video");
    if (video && video.srcObject) {
      const stream = video.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      video.srcObject = null;
    }
  }, []);

  const previewStyle = {
    height: "100%",
    width: "100%",
  };

  const videoConstraints = {
    facingMode: "environment", // This requests the rear camera
  };

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }} >
      {scanning && (
        <QrReader
          delay={300}
          style={previewStyle}
          onError={handleError}
          onScan={handleScan}
          constraints={{ video: videoConstraints }}
          showViewFinder={false}
        />
      )}
      {/* {!scanning && <p>Vendor_Qr_ID: {extractedValue}</p>} */}
    </div>
  );
};

export default Scanner;


// import { Html5QrcodeScanner } from "html5-qrcode";

// const Scanner = () => {
//   useEffect(() => {
//     const html5QrcodeScanner = new Html5QrcodeScanner(
//       "reader",
//       { fps: 10, qrbox: { width: 250, height: 250 } },
//       /* verbose= */ false
//     );

//     html5QrcodeScanner.render(
//       (decodedText, decodedResult) => {
//         console.log("Decoded text:", decodedText);
//         setExtractedValue(decodedText);
//         html5QrcodeScanner.clear();
//       },
//       (error) => console.error("Scan error:", error)
//     );

//     return () => {
//       html5QrcodeScanner.clear();
//     };
//   }, []);

//   return <div id="reader" style={{ width: "100%", height: "100%" }} />;
// };